import { Component, OnInit } from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {DomSanitizer} from '@angular/platform-browser';
import {AuthoriseResponseCard} from '../../../interfaces/card/responses/AuthoriseResponseCard';
import {CardService} from '../../../services/card/card.service';
import CallbackRequestCard from '../../../interfaces/card/requests/CallbackRequestCard';
import {ActivatedRoute, Router} from '@angular/router';
import {GoogleAnalyticsService} from '../../../services/google-analytics/google-analytics.service';
import {Observable, Subject} from 'rxjs';
import {TdsParams} from '../../../interfaces/tds/TdsParams';
import {environment} from '../../../../environments/environment';
import {HttpErrorResponse, HttpHandler} from '@angular/common/http';
import {TransactionService} from '../../../services/transaction/transaction.service';
import {TransactionStatus} from '../../../interfaces/transaction/TransactionStatus';
import {Session} from "../../../interfaces/session-data";
import {SetSessionStorage} from "../../shared/map.actions";
import {SessionService} from "../../../services/session/session.service";

@Component({
  selector: 'app-tds',
  templateUrl: './tds.component.html',
  styleUrls: ['./tds.component.scss']
})
export class TdsComponent implements OnInit {

  loading = true;
  merchantCustomTheme: HTMLStyleElement;
  mobile;
  cardSvgEl;
  tdsAuthed;
  callbackRequestCard: CallbackRequestCard;
  success = new Subject<boolean>();
  tdsParams: TdsParams;
  pollingInterval;
  statesToReturnOn = ['SETTLED', 'FAILED'];
  session: Session;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private sanitizer: DomSanitizer,
    private cardService: CardService,
    private router: Router,
    private route: ActivatedRoute,
    private googleAnalyticsService: GoogleAnalyticsService,
    private transactionService: TransactionService,
    private sessionService: SessionService
  ) {
    // console.log("=========================================== TDS COMPONENT CONSTRUCTOR");
    //V30C-68 remove acs form session data
    // console.log('REMOVING FROM SESSION ACS_FORM');
    sessionStorage.removeItem('acs-form');
    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });
    // Subscribe to query param return
    this.success.subscribe(
      (value) => {
        this.success.complete();
      },
      error => this.navigateToStatus()
    );
  }

  navigateToStatus() {
    this.loading = false;
    this.googleAnalyticsService
      .pageViewEvent('bankserv.tds', 'card.authenticate');
    this.googleAnalyticsService
      .eventEmitter('virtual.card.status.component', 'redirect.tds', 'authenticate.tds', 0);
    this.router.navigate(
      [`transaction-status`]);
  }

  getQueryParam(param: string): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get(param);
  }

  ngOnInit(): void {
    // console.log("=========================================== TDS COMPONENT NGONINIT");
    this.googleAnalyticsService
      .pageViewEvent('virtual.card.tds.component', 'authentication.tds.virtual.return');
    this.cardSvgEl = this.sanitizer.bypassSecurityTrustHtml(sessionStorage.getItem('card_svg_el'));
    if (sessionStorage.getItem('sessionToken') == null){
      this.sessionService.getSessionTokenWithNoSession(this.getQueryParam('sessionId'))
        .subscribe({
          next: data => sessionStorage.setItem('sessionData', JSON.stringify(data)),
          // error: err => this.handleError(err)
        });
      sessionStorage.setItem('sessionToken', this.getQueryParam('sessionId'));
    }
    this.transactionService.getTransactionStatusCard(sessionStorage.getItem('sessionToken'))
      .subscribe((data: TransactionStatus) => {
          if (data?.transactionState === 'TDS_AUTHENTICATED') {
            this.tdsAuthed = true;
            // this.authoriseCard();
            this.session = JSON.parse(sessionStorage.getItem('sessionData'));
            if (this.session.flow !== 'CARD_VERIFICATION') {
              this.authoriseCard();
            } else {
              this.navigateToStatus();
            }
          } else {
            this.navigateToStatus();
          }
        }, (error: HttpErrorResponse) => {
          this.navigateToStatus();
        }
      );



    //
    // this.tdsService.authenticateTds(sessionStorage.getItem('sessionToken'))
    //   .subscribe(
    //     value => {
    //       // Check somehow
    //       this.tdsAuthed = true;
    //       // this.authoriseCard();
    //       this.session = JSON.parse(sessionStorage.getItem('sessionData'));
    //       if (this.session.flow !== 'CARD_VERIFICATION') {
    //         this.authoriseCard();
    //       } else {
    //         this.navigateToStatus();
    //       }
    //     },
    //     error => {
    //       if (error.status === 409) {
    //         const timeout = 300;
    //         const inteval = 5;
    //         let count = 0;
    //         setTimeout(() => {
    //           this.clearIntervalCustom(this.pollingInterval);
    //         }, timeout * 1000);
    //         this.pollingInterval = setInterval(() => {
    //           count++;
    //           this.transactionService.getTransactionStatusCard(sessionStorage.getItem('sessionToken'))
    //             .subscribe((data: TransactionStatus) => {
    //               if (data.transactionState === 'SETTLED') {
    //                 this.navigateToStatus();
    //               }
    //             });
    //           // poll status call until certain states return including: ['FAILED', 'SETTLED']:
    //           // if this.statesToReturnOn.indexOf(data.transactionState) go to status, this.clearIntervalCustom(this.pollingInterval);
    //         }, inteval * 1000);
    //       } else {
    //         this.navigateToStatus();
    //       }
    //     }
    //   );
  }

  clearIntervalCustom(interval) {
    clearInterval(interval);
    this.navigateToStatus();
  }

  authoriseCard() {
    this.cardService.authoriseTransaction(sessionStorage.getItem('sessionToken')).subscribe((dataAuthorise: AuthoriseResponseCard) => {
      this.navigateToStatus();
    }, (err) => {
      if (err.status === 409) {
        const timeout = 300;
        const inteval = 5;
        let count = 0;
        setTimeout(() => {
          this.clearIntervalCustom(this.pollingInterval);
        }, timeout * 1000);
        this.pollingInterval = setInterval(() => {
          count++;
          this.transactionService.getTransactionStatusCard(sessionStorage.getItem('sessionToken'))
            .subscribe((data: TransactionStatus) => {
              if (data.transactionState === 'SETTLED') {
                this.navigateToStatus();
              }
            });
          // poll status call until certain states return including: ['FAILED', 'SETTLED']:
          // if this.statesToReturnOn.indexOf(data.transactionState) go to status, this.clearIntervalCustom(this.pollingInterval);
          // console.log('Polling Interval', `{${count * inteval} seconds have elapsed since timeout`, `${timeout - (count * inteval)} left`);
        }, inteval * 1000);
      } else {
        this.navigateToStatus();
      }
    });
  }

}
